/**
 * 基础菜单 商品管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '../charts/statistics' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>商品审核</el-breadcrumb-item>
    </el-breadcrumb>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column sortable prop="id" label="id" width="80"  align="center" >
      </el-table-column>
      <el-table-column prop="name" label="商品名" width="100"  align="center" >
      </el-table-column>
      <el-table-column prop="spe" label="规格" width="200" align="center" >
      </el-table-column>
      <el-table-column prop="label" label="标签" width="100" align="center" >
      </el-table-column>
      <el-table-column prop="introduce" label="介绍" width="100" align="center" >
      </el-table-column>
      <el-table-column prop="unit" label="单位" width="50" align="center" >
      </el-table-column>
      <el-table-column label="图片" width="300" align="center" >
        <template slot-scope="scope">
          <img style="width: 50%; height: auto;"  v-for="item in scope.row.img" :src="item" />
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="100" align="center" >
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="submitForm(scope.$index, scope.row.id)">通过</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { examineGoods, submitExamineGoods, PictureServer } from '../../api/userMG'
export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',
      editForm: {
        deptId: '',
        deptName: '',
        deptNo: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
    }
  },
  /**
   * 创建完毕
   */
  created() {
    this.getdata()
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取公司列表
    getdata() {
      this.loading = true
      examineGoods().then(res => {
        if (res.state == 200) {
          for(var i=0;i<res.data.goods.length;i++){
            if(res.data.goods[i][6].substring(0, 4)=="http"){
              var img_list=[res.data.goods[i][6]]
            }else{
              var img_list=[PictureServer.Goods+res.data.goods[i][6]]
            }
            console.log(res.data.goods[i][7],11111)
            if(res.data.goods[i][7])res.data.goods[i][7].split(",").forEach(e=>{
              if(e.substring(0, 4)=="http"){
                img_list.push(e)
              }else{
                img_list.push(PictureServer.Goods+e)
              }
            })
            var specificationsList=""//分解规格
            res.data.goods[i][2].split(',').forEach(k => {
              var speItem = k.split('^')
              specificationsList+=("规格名："+speItem[0]+"|"+"价格："+parseFloat(speItem[1])+"元\n")
            })

            this.listData.unshift({id:res.data.goods[i][0],name:res.data.goods[i][1],spe:specificationsList,label:res.data.goods[i][3],unit:res.data.goods[i][4],introduce:res.data.goods[i][5],img:img_list})
          }
          this.loading = false
        }
      })
    },
    // 编辑、增加页面保存方法
    submitForm(index,id) {
      submitExamineGoods(id).then(res => {
        this.editFormVisible = false
        this.loading = false
        if (res.state == 200) {
          this.$message({
            type: 'success',
            message: '审核通过成功！'
          })
          this.listData.splice(index,1)
        }
      })
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/school/working.vue